<template>
  <div>
    <v-container>
      <MigrationNotification />
      <v-row class="flex-column-reverse flex-md-row">
        <v-col cols="12" md="8" class="concerts__scroll">
          <h1 class="text-heading-5 my-5" v-if="!hasFilteredConcerts">Keine Konzerte verfügbar.</h1>
          <div v-for="(month, i) in filteredConcerts" :key="i">
            <h1 class="text-subtitle-1 mt-5 mb-3">{{ month.month }}</h1>
            <ConcertItem v-for="(konzert, i) in month.konzerte" :key="i" :konzert="konzert" />
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <Sidebar />
          <print-selector-multiple />
          <div class="mt-5">
            <v-btn text href="https://konzerthaus.at/FAQszumTicketing-Portal" target="_blank">FAQs zum
              Ticketing-Portal</v-btn>
          </div>
          <div class="mt-5">
            <v-btn text href="https://konzerthaus.at/impressum" target="_blank">Impressum</v-btn>
            <v-btn text href="https://konzerthaus.at/datenschutz" target="_blank">Datenschutzerklärung</v-btn>
          </div>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import ConcertItem from "@/components/ConcertItem";
import PrintSelectorMultiple from "@/components/PrintSelectorMultiple";
import Sidebar from "@/components/Sidebar";
import { mapGetters, mapActions } from "vuex";
import MigrationNotification from "../components/MigrationNotification.vue";

export default {
  components: {
    PrintSelectorMultiple,
    ConcertItem,
    Sidebar,
    MigrationNotification
  },
  data: () => ({
    searchString: null,
    loading: false,
  }),
  methods: {
    ...mapActions(["changePrintState"])
  },
  computed: {
    ...mapGetters([
      "allConcertsByMonth",
      "amountOfPrintItems",
      "printIsActive",
      "allChosenMonths",
      "filteredConcerts",
      "hasFilteredConcerts"
    ])
  }
};
</script>

<style lang="scss">
.concerts {
  &__scroll {
    height: 90vh;
    overflow: auto;
  }
}
</style>
